import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { DsconfigService } from '@services/dsconfig/dsconfig.service';
import { Observable, of, throwError } from 'rxjs';
import { RestConnService } from '../rest-conn/rest-conn.service';
import { Constants } from '@app/constants/constants';
import { StorageService } from '../storage/storage.service';
import { catchError } from 'rxjs/operators';
import { datesData } from '@app/pages/admin/calendarios/calendarios-bloqueo/block-day.service';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable()
export class FileExporterService {
  imputations: any;
  private CalendarExcel: any;


constructor(
  private http: HttpClient,
  private dsConfig: DsconfigService,
  public storage: StorageService,
  ) {}

  exportExcel(url: string, params?: any) {
    console.log("empezando con nuevo método");
    let headerEmail = this.storage.get(Constants.UserData.email) || '';
    let headerProfileId = this.storage.get(Constants.UserData.profileId) || '';
    let headerEmployeeNumber = this.storage.get(Constants.UserData.employeeNumber) || '';
    let headerEmployeeName = this.storage.get(Constants.UserData.employeeName) || '';

    console.log("url",url);
    let headers = new HttpHeaders();
    if (headerEmail) headers = headers.set('email', headerEmail);
    if (headerProfileId) headers = headers.set('profileId', headerProfileId);
    if (headerEmployeeNumber) headers = headers.set('employeeNumber', headerEmployeeNumber);
    if (headerEmployeeName) headers = headers.set('name', headerEmployeeName);

    // console.log("headers",headers);
    console.log("params",params);

    try
    {
      this.http
      .get(url, { headers, params, responseType: 'blob', observe: 'response' }) // Response as blob
      .pipe(
        catchError((error) => {
          console.error('Error occurred while exporting Excel:', error);
          return throwError(() => new Error('Failed to export Excel'));
        })
      )
      .subscribe((response) =>
      {
        let filename = 'export.xlsx'; // Default filename
        console.log("response.headers",response.headers);
        const contentDisposition = response.headers.get('Content-disposition');
        console.log("contentDisposition",contentDisposition);
        const matches = /filename="(.+)"/.exec(contentDisposition);
        if (matches != null && matches[1])
        {
          filename = matches[1];
        }


        const blob = new Blob([response.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8' });
        const downloadURL = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = filename; // File name
        link.click();
      });
    } catch (error)
    {
      console.error('An unexpected error occurred:', error);
    }
  }

  getReportEmployee(endDate: string, initDate: string, intEmpId: number) {
    this.imputations = {

      'imputations': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/imputation/filter/hours'//?dateEnd=' + endDate + '&dateInit=' + initDate + '&intEmpId=' + intEmpId
    };
    const params = {
      dateEnd: endDate,
      dateInit: initDate,
      intEmpId: intEmpId
    };
    //window.open(this.imputations.imputations, '_blank');
    this.exportExcel(this.imputations.imputations, params);
  }

  postCalendarExcel(fileData: File): Observable<any> {
    this.CalendarExcel = {
      'CalendarExcel':this.dsConfig.getUrlBase() + '/ess/v1/calendar/readExcel'
    };
    const url = this.dsConfig.getUrlBase() + '/ess/v1/calendar/readExcel';
    const formData = new FormData();
    formData.set('file', fileData);
    return this.http.post(url, formData, {
      headers: {
        'Authorization': 'Bearer ' + this.storage.get(Constants.UserData.TOKEN)
      }
    });

  }

}
